<template>
  <v-row dense justify="center">
    <v-col cols="12" class="title d-flex align-center">
      <v-icon color="secondary" left>mdi-forum</v-icon> {{ discussion.forum_topic.forum.title }} &raquo; {{ discussion.forum_topic.title }} &raquo; {{ discussion.title }}
    </v-col>
    <v-col cols="12" class="subtitle-2">
      Status da Discussão: {{ discussion.statusText }}
    </v-col>
    <v-col cols="12">
      <v-card outlined flat color="primary" dark>
        <v-card-title>Perguntas/Respostas da discussão</v-card-title>
        <v-card-text>
          <div :class="{'reply-content': !isHTML(discussion.description)}" v-html="discussion.description"/>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-btn text color="primary" block @click="addReply" class="my-4">
        <v-icon left>mdi-plus-circle</v-icon> Adicionar pergunta/resposta
      </v-btn>
    </v-col>
    <template v-if="paginate.total">
      <v-col cols="12" v-for="(reply, index) in replies" :key="index">
        <v-card outlined flat>
          <v-card-title>
            <v-row dense>
              <v-col class="grow">
                <span class="d-block">{{ reply.user.name }}</span>
                <span class="d-block text-caption">{{ date(reply) }}</span>
              </v-col>
              <v-col class="shrink" v-if="reply.user_id === user.id">
                <v-btn icon @click="editReply(reply.id)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-runtime-template :class="{'reply-content': !isHTML(reply.reply)}" :template="reply.reply"/>
          </v-card-text>
        </v-card>
      </v-col>
    </template>
    <template v-else>
      <v-col cols="12">
        <v-layout column class="pa-4">
          <v-icon size="124">mdi-emoticon-sad-outline</v-icon>
          <v-flex class="text-center">
            <span>Oops! Ainda não há perguntas/respostas para esta discussão.</span>
          </v-flex>
        </v-layout>
      </v-col>
    </template>
    <v-col cols="12" sm="10" md="8" class="text-center" v-if="replies.length">
      <v-pagination v-model="paginate.pageNumber" :length="paginate.length"/>
    </v-col>
    <router-view/>
  </v-row>
</template>

<script>
import { Forum } from '@/services/resources.js'
import { mapGetters } from 'vuex'
import VueRuntimeTemplate from '@/components/Utils/VueRuntimeTemplate'

export default {
  props: ['forumId', 'topicId', 'discussionId'],
  beforeRouteUpdate (to, from, next) {
    if (this.discussionId && from.name !== 'ambienteAluno.forum.topics.topic.openDiscussion') {
      this.loadRepliesFromDiscussion()
    }

    next()
  },
  components: {
    'v-runtime-template': VueRuntimeTemplate
  },
  data () {
    return {
      paginate: {
        pageNumber: 1,
        totalVisible: 5,
        total: 0,
        length: 5
      },
      discussion: {
        title: 'Título da discussão',
        description: 'Descrição',
        statusText: 'Status',
        forum_topic: {
          title: 'Título do Tópico de Fórum',
          forum: {
            title: 'Título do Fórum'
          }
        }
      },
      replies: []
    }
  },
  mounted () {
    Forum.getForumTopicDiscussion(this.discussionId)
      .then((response) => {
        this.discussion = { ...response.body.discussion }
      })
      .catch((error) => {
        console.log('responseError', error)
        this.$toasted.global.error({ message: error.statusText })
      })

    // Carrega as discussões referêntes a este tópico do fórum
    this.loadRepliesFromDiscussion()
  },
  methods: {
    loadRepliesFromDiscussion () {
      Forum.repliesFromDiscussion(this.discussionId, this.paginate.pageNumber)
        .then((response) => {
          this.replies = response.body.replies.data
          this.paginate.pageNumber = response.body.replies.current_page
          this.paginate.length = response.body.replies.last_page || 5
          this.paginate.total = response.body.replies.total
        })
        .catch((error) => {
          console.log('responseError', error)
          this.$toasted.global.error({ message: error.statusText })
        })
    },
    addReply () {
      this.$router.push({
        name: 'ambienteAluno.forum.topics.topic.openDiscussion.newReply',
        params: {
          forumId: this.forumId,
          topicId: this.topicId,
          discussionId: this.discussionId
        }
      })
    },
    editReply (replyId) {
      this.$router.push({
        name: 'ambienteAluno.forum.topics.topic.openDiscussion.editReply',
        params: {
          forumId: this.forumId,
          topicId: this.topicId,
          discussionId: this.discussionId,
          replyId: replyId
        }
      })
    },
    date (reply) {
      const createdDate = new Date(reply.created_at)
      let updatedDate = null
      if (reply.updated_at) {
        updatedDate = new Date(reply.updated_at)
      }

      return updatedDate
        ? 'Postada em: ' + createdDate.toLocaleString() + ' - Atualizada em: ' + updatedDate.toLocaleString()
        : 'Postada em: ' + createdDate.toLocaleString()
    },
    isHTML (text) {
      return RegExp.prototype.test.bind(/(<([^>]+)>)/i)(text)
    }
  },
  watch: {
    'paginate.pageNumber': function () {
      // Carrega as discussões referêntes a este tópico do fórum
      // de acordo com a paginação selecionada
      this.loadRepliesFromDiscussion()
    }
  },
  computed: {
    ...mapGetters({
      user: 'App/user'
    })
  }
}
</script>
<style lang="scss">
.replies .reply-content {
  white-space: pre-wrap;
}
</style>
